module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-700.7681725c85c6d67ea004.eot";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.eot
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.eot
// module chunks = styles